import React from 'react';
import { Text } from '@rsos/base-components';
import type { KeywordSet } from '@rsos/reduxDataStore';
import { Tier1Tag, Tier2Tag, Tier3Tag } from './Tier.styles';

export const humanReadableTier = (tierId: KeywordSet['tier_id']) => {
  return { 'tier-1': 'Tier 1', 'tier-2': 'Tier 2', 'tier-3': 'Tier 3' }[tierId];
};

export const Tier = ({ tierId }: { tierId: KeywordSet['tier_id'] }) => {
  const Component = {
    'tier-1': Tier1Tag,
    'tier-2': Tier2Tag,
    'tier-3': Tier3Tag,
  }[tierId];
  const text = humanReadableTier(tierId);
  return (
    <Component>
      <Text size="xsmall">{text}</Text>
    </Component>
  );
};
